import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (3 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisBildirim = {

  GetUserNotifications(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-user-notifications`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  SetUserNotificationAsRead(token, notificationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-user-notification-as-read`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        notificationID
      }
    });
  },

  SetAllUserNotificationsAsRead(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-all-user-notifications-as-read`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
};

export default servisBildirim;
